import type { LeDataUsageSummary } from '~/types/leData';

/**
 * One AskRichard session, which is how several turns come to share a cache.
 *
 * The id arrives on the first turn's reply, so the handle is mutable and the
 * caller keeps it. A session serves one turn at a time: concurrent work takes
 * a session each, which is why this is a value the caller passes rather than
 * state the asking code owns.
 */
export type LensBuildSession = { id: string };

export function newBuildSession(): LensBuildSession {
  return { id: '' };
}

export type BuildAnswer = {
  answer: string;
  sqlBlocks: Array<string>;
  streamError: string;
  usage?: LeDataUsageSummary;
};

/** Writing SQL to a settled specification is mechanical; deciding the specification is not. */
export type LensTurnEffort = 'low' | 'medium';

export type AskOptions = { session?: LensBuildSession; effort?: LensTurnEffort; signal?: AbortSignal };

export type Ask = (question: string, options?: AskOptions) => Promise<BuildAnswer>;
